<template>
    <q-layout
            view="lhh LpR lff"
            container
            class="shadow-2 rounded-borders window-height"
            :class="$q.dark.isActive ? 'bg-grey-9' : 'bg-grey-3'"
    >
        <q-header class="bg-primary">
            <q-toolbar>
                <q-toolbar-title>Отчет по обмену</q-toolbar-title>
                <q-btn @click="downloadReport" :loading="isLoading" :disable="isLoading" color="red" class="q-mr-md">Скачать отчет</q-btn>
                <q-btn flat @click="drawerRight = !drawerRight" round dense icon="menu"/>
            </q-toolbar>
        </q-header>


        <q-drawer
                side="right"
                v-model="drawerRight"
                bordered
                :width="308"
                :breakpoint="500"
        >
            <q-scroll-area class="fit">
                <div class="q-pa-sm" style="padding-bottom: 40px">
                    <q-date v-model="filters.sended_at.value" range mask="YYYY-MM-DD" class="q-mb-sm"/>

                    <q-btn-toggle
                        class="q-mb-sm fullWidth"
                        v-model="separate"
                        toggle-color="primary"
                        :options="[
                            {label: 'Общая', value: false},
                            {label: 'По дням', value: 'day'}
                          ]"
                        @update:modelValue="saveSettings"
                    />

                    <q-btn-toggle
                        class="q-mb-sm fullWidth"
                        v-model="type"
                        toggle-color="primary"
                        :options="[
                              {label: 'First click', value: 'first'},
                              {label: 'Last click', value: 'last'},
                            ]"
                        unelevated
                        @update:modelValue="saveSettings"
                    />

                    <q-btn-toggle
                        class="q-mb-sm fullWidth"
                        v-model="timezone"
                        toggle-color="primary"
                        :options="[
                                {label: 'UTC', value: '+00:00'},
                                {label: 'UTC+3', value: '+03:00'},
                              ]"
                        unelevated
                        @update:modelValue="saveSettings"
                    />

                    <q-select
                        class="q-mb-md"
                        filled
                        v-model="filters.sites.value"
                        multiple
                        :options="objectToOptions(settings.sites)"
                        counter
                        use-chips
                        stack-label
                        label="По указанным сайтам"
                        hint="Выбрано"
                        behavior="dialog"
                        use-input
                    />

                    <q-select
                        class="q-mb-sm"
                        filled
                        v-model="filters.services.value"
                        multiple
                        :options="objectToOptions(settings.services)"
                        counter
                        use-chips
                        stack-label
                        label="По указанным сервисам"
                        hint="Выбрано"
                        behavior="dialog"
                        use-input
                    />


                    <div class="q-pa-sm">
                        <q-input v-model="filters.utmSource.value" label="UTM Source"/>
                        <q-input v-model="filters.utmCampaign.value" label="UTM Campaign"/>
                    </div>


                    <q-checkbox v-model="filters.full_fill.value" toggle-indeterminate label="Полное заполнение"/>
                    <q-checkbox v-model="filters.requestPostback.value" toggle-indeterminate label="Отправлен постбек"/>
                    <q-checkbox v-model="filters.phoneChecked.value" toggle-indeterminate label="Телефон проверен"/>
                    <q-checkbox v-model="filters.emailValid.value" toggle-indeterminate label="Email валидный"/>
                    <q-checkbox v-model="filters.emailDoi.value" toggle-indeterminate label="Email подтвержден DOI"/>
                    <q-checkbox v-model="filters.uniqueCurrent.value" toggle-indeterminate label="Уникальный (текущий сайт)"/>
                    <q-checkbox v-model="filters.uniqueAll.value" toggle-indeterminate label="Уникальный (все сайты)"/>
                    <q-checkbox v-model="filters.gclid.value" toggle-indeterminate label="Есть Gclid"/>
                    <div class="memo">
                        Чекбокс имеет 3 состояния - влючен (да), выключен (нет) и неизвестен (-)
                    </div>
                </div>
                <div class="q-pa-sm fixed-bottom bg-white">
                    <q-btn class="full-width" :loading="isLoading" :disabled="isLoading" color="primary"
                           @click="saveSettings" label="Построить отчет"/>
                </div>
            </q-scroll-area>
        </q-drawer>

        <q-page-container>
            <q-page style="padding-top: 30px" class="q-pa-md" v-if="data.records && data.columns">
              <q-table
                  title="Общая статистика обмена"
                  :rows="data.records"
                  :columns="data.columns"
                  row-key="name"
                  :pagination="{rowsPerPage: 0}"
              />
              <div class="totalCount">Всего сохраненных лидов за период: <strong>{{data.all}}</strong></div>
            </q-page>

        </q-page-container>
    </q-layout>

</template>

<script setup>

import {onMounted, reactive, ref} from "vue";
import {ajax, ajaxDownload, objectToOptions} from "@/assets/js/functions";
import '@/assets/css/style.css'


const isLoading = ref(true)
const drawerRight = ref(true)
const settings = ref({})
const separate = ref(false)
const type = ref('first')
const timezone = ref('+00:00')
const data = ref({})

const filters = reactive({
    sended_at: {
        value: new Date().toISOString().split('T')[0],
        column: 'sended_at',
        operator: 'BETWEEN_DATES',
        subTable: 'le'
    },
    sites: {
        value: null,
        column: 'site',
        operator: 'IN'
    },
    services: {
        value: null,
        column: 'service',
        operator: 'IN',
        subTable: 'le'
    },
    full_fill: {
        value: null,
        column: 'full_fill',
        operator: '='
    },
    utmSource: {
        value: null,
        column: 'utm_source',
        operator: 'LIKE'
    },
    utmCampaign: {
        value: null,
        column: 'utm_campaign',
        operator: 'LIKE'
    },
    requestPostback: {
        value: null,
        column: 'request_postback',
        operator: '='
    },
    phoneChecked: {
        value: null,
        column: 'phone_checked',
        operator: '='
    },
    emailValid: {
        value: null,
        column: 'email_valid',
        operator: '='
    },
    emailDoi: {
        value: null,
        column: 'email_doi',
        operator: '='
    },
    uniqueCurrent: {
        value: null,
        column: 'unique_current',
        operator: '='
    },
    uniqueAll: {
        value: null,
        column: 'unique_all',
        operator: '='
    },
    gclid: {
      value: null,
      column: 'gclid',
      operator: 'NOT EMPTY'
    }
})

onMounted(async () => {
    ajax({ action: "getExchangeReportSettings" }, (data) => {
        settings.value = data
        isLoading.value = false
    })

    saveSettings()
})

const saveSettings = () => {
    isLoading.value = true

    ajax({
        action: "getLeadExchangeReport",
        params: filters,
        separate: separate.value,
        type: type.value,
        timezone: timezone.value
    }, (response) => {
        data.value = response
        isLoading.value = false
        console.log(response)
    })
}

const downloadReport = () => {
    isLoading.value = true

    let sendedAtValue = filters.sended_at.value;
    if (typeof sendedAtValue === 'object' && sendedAtValue !== null && 'from' in sendedAtValue && 'to' in sendedAtValue) {
        sendedAtValue = `${sendedAtValue.from} - ${sendedAtValue.to}`;
    }

    ajaxDownload({
        action: "downloadExchangeReport",
        params: filters,
        type: type.value,
    }, () => {
        isLoading.value = false
    }, 'exchangeReport_'+ sendedAtValue +'.csv')
}

</script>

<style scoped>
.totalCount{
    font-size: 14px;
    font-weight: 400;
    margin: 20px 0;
}
</style>